module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC3SURBVEhL5dQxCsJAEIXhBc9hFTypiH1uIFpoYS4lKIqFnkD/By6EMJkdNCnUBx+EzczbKkl/kwpbXF70rLNBoiKVPjp0NsglO3TLM717KxPMcYBV3KYZzWonnCWsMs8C4RxhlXi0E84ZVonnhHBqWCUe7YQywxVWiUc72i2mgVUQsUcxd1jLETcUM/oFG1jLEWsU0/fvKdEXPUUoGlwh+qvQbLjcSy4dLd95QS7t83Gs0rafTkpPc5LMmkvzae4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-oak-tree/dark/24.png
// module id = 2276
// module chunks = 2